import { render } from "./ContactLanguages.vue?vue&type=template&id=a42eb674"
import script from "./ContactLanguages.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactLanguages.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ContactLanguages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a42eb674"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a42eb674', __exports__)) {
    api.reload('a42eb674', __exports__)
  }
  
  module.hot.accept("./ContactLanguages.vue?vue&type=template&id=a42eb674", () => {
    api.rerender('a42eb674', render)
  })

}


export default __exports__